import React from 'react';
import { Capacitor } from '@capacitor/core';

/**
 * Apple App Store Guideline 3.1.2(c) compliance component.
 * Displays auto-renewal notice, duration, pricing, and legal links.
 * Only renders on iOS native builds.
 */
const AppleSubscriptionDisclosure = ({ planName, price, durationDays }) => {
  const isNativeIOS = Capacitor.isNativePlatform() && Capacitor.getPlatform() === 'ios';
  if (!isNativeIOS) return null;

  const durationText = durationDays >= 360
    ? '1 Year'
    : durationDays >= 180
      ? '6 Months'
      : durationDays >= 90
        ? '3 Months'
        : durationDays >= 60
          ? '2 Months'
          : '1 Month';

  const openURL = (url) => {
    window.open(url, '_blank', 'noopener');
  };

  return (
    <div className="mb-6 p-4 bg-white/5 border border-white/10 rounded-2xl backdrop-blur-md space-y-3">
      {/* Plan Name for Compliance */}
      {planName && (
        <h4 className="text-sm font-bold text-white mb-2">{planName}</h4>
      )}

      <div className="flex items-center gap-2">
        <svg className="w-4 h-4 text-yellow-500 shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" />
        </svg>
        <span className="text-xs font-bold text-yellow-500 uppercase tracking-wider">Auto-Renewable Subscription</span>
      </div>

      <div className="space-y-1 text-xs text-gray-400 leading-relaxed">
        {price && (
          <p><span className="text-gray-300 font-semibold">Price:</span> {price} / {durationText}</p>
        )}
        <p><span className="text-gray-300 font-semibold">Duration:</span> {durationText}</p>
        <p className="mt-2 leading-5">
          Payment will be charged to your Apple ID account at confirmation of purchase.
          Your subscription automatically renews unless cancelled at least 24 hours before the end
          of the current period. You can manage or cancel your subscriptions in your Apple ID
          Account Settings any time after purchase.
        </p>
      </div>

      <div className="flex gap-4 pt-1 border-t border-white/10">
        <button
          onClick={() => openURL('https://www.apple.com/legal/internet-services/itunes/dev/stdeula/')}
          className="text-xs text-yellow-500/80 hover:text-yellow-400 underline underline-offset-2 transition-colors"
        >
          Terms of Use
        </button>
        <button
          onClick={() => openURL('https://drvivara.cloud/#/privacy')}
          className="text-xs text-yellow-500/80 hover:text-yellow-400 underline underline-offset-2 transition-colors"
        >
          Privacy Policy
        </button>
      </div>
    </div>
  );
};

export default AppleSubscriptionDisclosure;
